import { getOptionsLocalized } from "./optionsLocalized";
import { checkIsValidSearch, updateErrorsSearch } from "./manageValidation";

const localizedSelected = (filter, selected) => {
  const optionsLocalized = getOptionsLocalized(filter).find(
    (option) => option.value === selected
  );
  if (!optionsLocalized) {
    return;
  }
  return optionsLocalized.label;
};

export const getButtonText = (selected, text, name) => {

  if (!selected) {
    return;
  }
  const selectedExistedInFilters = selected.filter((item) => {
    return getOptionsLocalized(name)?.find((option) => option.value === item)
  });

  return selectedExistedInFilters.length
    ? `${localizedSelected(name, selectedExistedInFilters[0])}${selectedExistedInFilters.length > 1
      ? ` + ${selectedExistedInFilters.length - 1}`
      : ""
    }`
    : text;
};


export const getSelected = ({
  modalId,
  searchType,
  countries,
  usState,
  organizationFields,
  businessFields,
  category,
  type,
  fields,
  newsFields,
  blogFields,
  findType,
  findFields,
  findState,
  searchedProp,
  hotSpotFields,
  greenSpotFields
}) => {
  // eslint-disable-next-line default-case
  switch (modalId) {
    case "searchType":
      return searchType;
    case "countries":
      return countries;
    case "states":
    case "usState":
      return usState;
    case "organizationFields":
      return organizationFields;
    case "businessFields":
      return businessFields;
    case "category":
      return category;
    case "type":
      return type;
    case "findType":
      return findType;
    case "findFields":
      return findFields;
    case "findState":
      return findState;
    case "fields":
      return fields;
    case "newsFields":
      return newsFields;
    case "blogFields":
      return blogFields;
    case "spotProp":
      return searchedProp;
    case "hotSpotFields":
      return hotSpotFields
    case "greenSpotFields":
      return greenSpotFields
  }
};

export function handleFieldChange(value) {

  if (this.filter === "searchType") {
    this.changeFilter([value]);
    this.changeFilter([], "businessFields");
    this.changeFilter([], "organizationFields");
  }
  if (this.filter === "countries") {
    this.changeFilter([value]);
  }
  if (this.filter === "usState" || this.filter === "states") {
    this.changeFilter([value]);
  }
  if (this.filter === "newsFields") {
    this.changeFilter([value]);
  }
  if (this.filter === "blogFields") {
    this.changeFilter([value]);
  }
  if (this.filter === "type") {
    this.changeFilter([value])
  }
  if (this.filter === "findType") {
    this.changeFilter([value])
  }
  if (this.filter === "spotProp") {
    this.changeFilter([value])
  }
  if (value === "all") {
    this.selected?.[0] === "all"
      ? this.changeFilter([], this.filter)
      : this.changeFilter(["all"], this.filter);
  }
  if (value !== "all" && this.filter !== "searchType" && this.filter !== "countries" && this.filter !== "usState" && this.filter !== "states" && this.filter !== "type" && this.filter !== "findType" && this.filter !== "spotProp" && this.filter !== "newsFields" && this.filter !== "blogFields") {
    const unSelectIndex = this.selected.indexOf(value);
    const newSelectedFields = [...this.selected];
    unSelectIndex !== -1
      ? newSelectedFields.splice(unSelectIndex, 1)
      : newSelectedFields.push(value);
    this.changeFilter(newSelectedFields);
  }
  value &&
    this.cancelValidationError &&
    this.cancelValidationError(this.filter);
}

export function handleHotSpotFormFieldChange(value) {
  if (value === "all") {
    this.selected[0] === "all"
      ? this.changeFilter([], this.filter)
      : this.changeFilter(["all"], this.filter);
  }
  if (value !== "all") {
    const unSelectIndex = this.selected.indexOf(value);
    const newSelectedFields = [...this.selected];
    unSelectIndex !== -1
      ? newSelectedFields.splice(unSelectIndex, 1)
      : newSelectedFields.push(value);
    this.changeFilter(newSelectedFields);
  }
  value &&
    this.cancelValidationError &&
    this.cancelValidationError(this.filter);
}


export function nextStep() {
  const { toggleModal, state, history, getSpots, getSpotsLocation } = this;
  const type = state.searchType[0];
  switch (type) {
    case "NGO":
      if (!state.organizationFields.length) {
        toggleModal("organizationFields");
      }
      if (!state.countries.length) {
        toggleModal("countries");
      }
      if (state.countries.length && state.organizationFields.length) {
        toggleModal();
        getSpotsLocation({
          searchType: type,
          countries: state.countries,
          organizationFields: state.organizationFields,
          history
        });
      }
      break;
    case "business":
      if (!state.businessFields.length) {
        toggleModal("businessFields");
      }

      if (!state.countries.length) {
        toggleModal("countries");
      }
      if (state.countries.length && state.businessFields.length) {
        toggleModal();
        getSpotsLocation({
          searchType: type,
          countries: state.countries,
          businessFields: state.businessFields,
          history
        });
      }
      break;
    case "media":
      if (!state.countries.length) {
        toggleModal("countries");
      }
      if (state.countries.length) {
        toggleModal();
        getSpotsLocation({
          searchType: type,
          countries: state.countries,
          history

        });
      }

      break;
    case "government":
      if (!state.countries.length) {
        toggleModal("countries");
      }
      if (state.countries.length) {
        toggleModal();
        getSpotsLocation({
          searchType: type,
          countries: state.countries,
          history

        });
      }
      break;
    case "hotSpot":
      if (!state.organizationFields.length) {
        toggleModal("organizationFields");
      }
      if (!state.countries.length) {
        toggleModal("countries");
      }
      if (state.countries.length && state.organizationFields.length) {
        toggleModal();
        getSpotsLocation({
          searchType: type,
          countries: state.countries,
          organizationFields: state.organizationFields,
          history
        });
      }
      break;
    default:
  }
}

export const onSearchSubmit = ({
  state,
  history,
  setValidationError,
  getSpots,
  getSpotsLocation,
  activePage,
  setSpotsPage
}) => {
  const { countries, organizationFields, businessFields, searchType } = state;

  if (
    !checkIsValidSearch({
      state,
    })
  ) {
    updateErrorsSearch({
      state: { countries, organizationFields, businessFields, searchType },
      setValidationError,
    });
    return;
  }
  setSpotsPage(1);

  getSpotsLocation({
    searchType: searchType[0],
    countries,
    // TO DO Don't send if we don't need in request this field
    organizationFields,
    businessFields,
    history
  });
  setValidationError([]);
};
